export const getSeverityCategory = (score: number) => {
  if (score >= 15)
    return { label: '高度心理困擾，建議立即尋求身心醫療專業協助', color: 'bg-red-500' };

  if (score >= 10 && score < 15)
    return { label: '中度心理困擾，建議尋求心理諮商或專業諮詢', color: 'bg-yellow-500' };

  if (score >= 6 && score < 10)
    return { label: '輕度心理困擾，建議找個信任的人聊聊，抒發情緒', color: 'bg-yellow-500' };

  if (score >= 0 && score < 6)
    return { label: '心理健康良好。', color: 'bg-yellow-500' };
};